module.exports = function (modules) {
  var installedModules = {};

  function __webpack_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: !1,
      exports: {}
    };
    return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), module.l = !0, module.exports;
  }

  return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function (exports, name, getter) {
    __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
      enumerable: !0,
      get: getter
    });
  }, __webpack_require__.r = function (exports) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(exports, "__esModule", {
      value: !0
    });
  }, __webpack_require__.t = function (value, mode) {
    if (1 & mode && (value = __webpack_require__(value)), 8 & mode) return value;
    if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
    var ns = Object.create(null);
    if (__webpack_require__.r(ns), Object.defineProperty(ns, "default", {
      enumerable: !0,
      value: value
    }), 2 & mode && "string" != typeof value) for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    return ns;
  }, __webpack_require__.n = function (module) {
    var getter = module && module.__esModule ? function () {
      return module.default;
    } : function () {
      return module;
    };
    return __webpack_require__.d(getter, "a", getter), getter;
  }, __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = "./index.js");
}({
  "../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js": function node_modulesBabelRuntimeCorejs3CoreJsObjectDefinePropertyJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/object/define-property");
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/classCallCheck.js": function node_modulesBabelRuntimeCorejs3HelpersClassCallCheckJs(module, exports) {
    module.exports = function (instance, Constructor) {
      if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/createClass.js": function node_modulesBabelRuntimeCorejs3HelpersCreateClassJs(module, exports, __webpack_require__) {
    var _Object$defineProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js");

    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), _Object$defineProperty(target, descriptor.key, descriptor);
      }
    }

    module.exports = function (Constructor, protoProps, staticProps) {
      return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
    };
  },
  "../../node_modules/webpack/buildin/global.js": function node_modulesWebpackBuildinGlobalJs(module, exports) {
    var g;

    g = function () {
      return this;
    }();

    try {
      g = g || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (g = window);
    }

    module.exports = g;
  },
  "./ServiceManager.js": function ServiceManagerJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    (function (global) {
      var _context,
          _babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"),
          _babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__WEBPACK_IMPORTED_MODULE_0__),
          _babel_runtime_corejs3_core_js_stable_instance_index_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/index-of"),
          _babel_runtime_corejs3_core_js_stable_instance_index_of__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_index_of__WEBPACK_IMPORTED_MODULE_1__),
          _babel_runtime_corejs3_core_js_stable_symbol_for__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/symbol/for"),
          _babel_runtime_corejs3_core_js_stable_symbol_for__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_babel_runtime_corejs3_core_js_stable_symbol_for__WEBPACK_IMPORTED_MODULE_2__),
          _babel_runtime_corejs3_core_js_stable_instance_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/find"),
          _babel_runtime_corejs3_core_js_stable_instance_find__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_find__WEBPACK_IMPORTED_MODULE_3__),
          _babel_runtime_corejs3_core_js_stable_instance_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/map"),
          _babel_runtime_corejs3_core_js_stable_instance_map__WEBPACK_IMPORTED_MODULE_4___default = __webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_map__WEBPACK_IMPORTED_MODULE_4__),
          _babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/classCallCheck.js"),
          _babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = __webpack_require__.n(_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__),
          _babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/createClass.js"),
          _babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = __webpack_require__.n(_babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__),
          _jutro_logger__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("@jutro/logger"),
          _ServiceRegistry__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./ServiceRegistry.js");

      var ServiceManager = function () {
        function ServiceManager() {
          _babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, ServiceManager), this.registry = new _ServiceRegistry__WEBPACK_IMPORTED_MODULE_8__.a();
        }

        return _babel_runtime_corejs3_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(ServiceManager, [{
          key: "register",
          value: function value(id, Service, options) {
            this.registry.register(id, Service, options);
          }
        }, {
          key: "getService",
          value: function value(id) {
            if (this.registry.hasRegistration(id)) return this.registry.getRegistration(id).getService();

            _jutro_logger__WEBPACK_IMPORTED_MODULE_7__.log.warning("No service available for id '".concat(id, "'"));
          }
        }, {
          key: "getServiceByContract",
          value: function value(contract, resolver) {
            var implementors = this.registry.getImplementorsOf(contract);
            if (0 === implementors.length) return;
            if (!resolver) return implementors.length > 1 && _jutro_logger__WEBPACK_IMPORTED_MODULE_7__.log.warning("Contract \"".concat(contract, "\" has multiple implementations, but no resolver provided")), this.getService(implementors[0].id);

            var metadata = _babel_runtime_corejs3_core_js_stable_instance_map__WEBPACK_IMPORTED_MODULE_4___default()(implementors).call(implementors, function (reg) {
              return reg.getMetadata();
            }),
                selected = _babel_runtime_corejs3_core_js_stable_instance_find__WEBPACK_IMPORTED_MODULE_3___default()(metadata).call(metadata, resolver);

            if (void 0 !== selected) return this.getService(selected.id);

            _jutro_logger__WEBPACK_IMPORTED_MODULE_7__.log.warning("Resolver callback did not find any implementations");
          }
        }, {
          key: "listRegistrations",
          value: function value() {
            _jutro_logger__WEBPACK_IMPORTED_MODULE_7__.log.info("Currently registered services: " + this.registry.getRegistrationIds().join(", "));
          }
        }]), ServiceManager;
      }();

      var SERVICE_MANAGER_KEY = _babel_runtime_corejs3_core_js_stable_symbol_for__WEBPACK_IMPORTED_MODULE_2___default()("jutro.services.serviceManager");

      -1 === _babel_runtime_corejs3_core_js_stable_instance_index_of__WEBPACK_IMPORTED_MODULE_1___default()(_context = _babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__WEBPACK_IMPORTED_MODULE_0___default()(global)).call(_context, SERVICE_MANAGER_KEY) && (global[SERVICE_MANAGER_KEY] = new ServiceManager()), __webpack_exports__.a = global[SERVICE_MANAGER_KEY];
    }).call(this, __webpack_require__("../../node_modules/webpack/buildin/global.js"));
  },
  "./ServiceRegistry.js": function ServiceRegistryJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.d(__webpack_exports__, "a", function () {
      return ServiceRegistry_ServiceRegistry;
    });

    var keys_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/object/keys"),
        keys_default = __webpack_require__.n(keys_),
        for_each_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/for-each"),
        for_each_default = __webpack_require__.n(for_each_),
        is_array_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/array/is-array"),
        is_array_default = __webpack_require__.n(is_array_),
        classCallCheck = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/classCallCheck.js"),
        classCallCheck_default = __webpack_require__.n(classCallCheck),
        createClass = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/createClass.js"),
        createClass_default = __webpack_require__.n(createClass),
        external_lodash_ = __webpack_require__("lodash"),
        external_lodash_default = __webpack_require__.n(external_lodash_),
        logger_ = __webpack_require__("@jutro/logger");

    var Options_Options = function () {
      function Options(options) {
        classCallCheck_default()(this, Options), this.options = options;
      }

      return createClass_default()(Options, [{
        key: "onOption",
        value: function value(optionName, callback) {
          var option = this.options[optionName];
          void 0 !== option && callback(option);
        }
      }]), Options;
    }(),
        ServiceRegistry_Registration = function () {
      function Registration(id, Service, lazy) {
        classCallCheck_default()(this, Registration), this.id = id, this.name = Service.name || Service.constructor.name, this.attributes = {}, lazy ? this.init = Service : this.service = new Service();
      }

      return createClass_default()(Registration, [{
        key: "associate",
        value: function value(attributes) {
          this.attributes = external_lodash_default.a.merge(this.attributes, attributes);
        }
      }, {
        key: "getMetadata",
        value: function value() {
          return external_lodash_default.a.merge({
            id: this.id,
            name: this.name
          }, this.attributes);
        }
      }, {
        key: "isLazy",
        value: function value() {
          return !!this.init;
        }
      }, {
        key: "initializeService",
        value: function value() {
          if (this.init) {
            var Service = this.init;
            this.service = new Service(), this.init = null;
          } else logger_.log.warning("Service is already instantiated");
        }
      }, {
        key: "getService",
        value: function value() {
          return this.isLazy() && this.initializeService(), this.service;
        }
      }]), Registration;
    }(),
        ServiceRegistry_ServiceRegistry = function () {
      function ServiceRegistry() {
        classCallCheck_default()(this, ServiceRegistry), this.registrations = {}, this.implementations = {};
      }

      return createClass_default()(ServiceRegistry, [{
        key: "register",
        value: function value(id, Service) {
          var _this = this;

          var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          if (this.registrations[id]) logger_.log.warning("Service with id '".concat(id, "' has already been registered"));else {
            var registration = new ServiceRegistry_Registration(id, Service, options.lazy),
                opts = new Options_Options(options);
            opts.onOption("implements", function (implemented) {
              var contracts = is_array_default()(implemented) ? implemented : [implemented];
              for_each_default()(contracts).call(contracts, function (c) {
                if (!c.implementedBy(Service)) throw new Error("Service ".concat(Service.name || Service.constructor.name, " does not implement: ").concat(c));
                var key = c.hash();
                _this.implementations[key] || (_this.implementations[key] = []), _this.implementations[key].push(registration);
              });
            }), opts.onOption("attributes", function (attributes) {
              return registration.associate(attributes);
            }), this.registrations[id] = registration;
          }
        }
      }, {
        key: "hasRegistration",
        value: function value(id) {
          return !!this.registrations[id];
        }
      }, {
        key: "getRegistration",
        value: function value(id) {
          return this.registrations[id];
        }
      }, {
        key: "getRegistrationIds",
        value: function value() {
          return keys_default()(this.registrations);
        }
      }, {
        key: "getImplementorsOf",
        value: function value(contract) {
          var implementors = this.implementations[contract.hash()];
          return (!implementors || implementors.length <= 0) && logger_.log.warning("No implementors found for: " + contract), implementors || [];
        }
      }]), ServiceRegistry;
    }();
  },
  "./index.js": function indexJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__), __webpack_require__.d(__webpack_exports__, "ServiceManager", function () {
      return ServiceManager.a;
    }), __webpack_require__.d(__webpack_exports__, "service", function () {
      return service;
    });

    var ServiceManager = __webpack_require__("./ServiceManager.js"),
        service = function service(id) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return function (target) {
        ServiceManager.a.register(id, target, options);
      };
    };
  },
  "@babel/runtime-corejs3/core-js-stable/array/is-array": function babelRuntimeCorejs3CoreJsStableArrayIsArray(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/array/is-array");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/find": function babelRuntimeCorejs3CoreJsStableInstanceFind(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/find");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/for-each": function babelRuntimeCorejs3CoreJsStableInstanceForEach(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/index-of": function babelRuntimeCorejs3CoreJsStableInstanceIndexOf(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/index-of");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/map": function babelRuntimeCorejs3CoreJsStableInstanceMap(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/map");
  },
  "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols": function babelRuntimeCorejs3CoreJsStableObjectGetOwnPropertySymbols(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
  },
  "@babel/runtime-corejs3/core-js-stable/object/keys": function babelRuntimeCorejs3CoreJsStableObjectKeys(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/object/keys");
  },
  "@babel/runtime-corejs3/core-js-stable/symbol/for": function babelRuntimeCorejs3CoreJsStableSymbolFor(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/symbol/for");
  },
  "@jutro/logger": function jutroLogger(module, exports) {
    module.exports = require("@jutro/logger");
  },
  "core-js-pure/features/object/define-property": function coreJsPureFeaturesObjectDefineProperty(module, exports) {
    module.exports = require("core-js-pure/features/object/define-property");
  },
  lodash: function lodash(module, exports) {
    module.exports = require("lodash");
  }
});